<template>
  <div class="modal fade" id="cuModal" tabindex="-1" role="dialog" aria-labelledby="cuModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="cuModalLabel">{{ modalContent.title }}</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <label class="custom-label" for="name">Name</label>
            <input class="form-control" id="name"
              :class="form.errors.has('name') ? 'is-invalid' : ''"
              v-model="form.name" @keydown="form.errors.clear('name')"
            >
            <div class="invalid-feedback"
              v-if="form.errors.has('name')"
              v-text="form.errors.get('name')"
            />
          </div>
          <div class="form-group">
            <label class="custom-label" for="email">Email</label>
            <input class="form-control" id="email"
              :class="form.errors.has('email') ? 'is-invalid' : ''"
              v-model="form.email" @keydown="form.errors.clear('email')"
            >
            <div class="invalid-feedback"
              v-if="form.errors.has('email')"
              v-text="form.errors.get('email')"
            />
          </div>
          <div class="form-group form-check" v-if="modalContent.showInvite">
            <input type="checkbox" class="form-check-input" v-model="form.invite" id="invite">
            <label class="form-check-label" for="invite">Send manager an invitation for account creation</label>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary"
            :disabled="form.isWorking()"
            @click="handleSubmit"
          >
            <span v-if="form.isWorking()">Checking Input...</span>
            <span v-else>{{ modalContent.submitText }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import createUpdateMixin from './../cu-modal-mixin'

  export default {
    mixins: [createUpdateMixin],
    data() {
      return {
      }
    },
  }
</script>



// WEBPACK FOOTER //
// resources/js/components/users/CuModal.vue